module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "columns"
  }, [_c('li', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('p', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "video"
  }, [_c('video', {
    attrs: {
      "src": _vm.data.src,
      "poster": _vm.data.poster,
      "controls": "controls"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("视频文件较大，建议在WiFi环境下观看。")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5348e0e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoList.vue
// module id = 469
// module chunks = 1